import { MenuCategoryUpdatePage } from "@/features/menu-category/pages/MenuCategoryUpdatePage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/menu-category/$id/update")({
	component: RouteComponent,
});

function RouteComponent() {
	const { id } = Route.useParams();
	return <MenuCategoryUpdatePage id={id} />;
}
